/**
 * Prevents the element from going to its target.
 * Has a checker to make sure there are no multiple instances of the same event.
 * @param {HTMLElement} elm 
 * @param {function} cb 
 */
export function preventDefault(elm, cb) {
  if (elm.dataset.clickEvent != 'true') {
    elm.dataset.clickEvent = 'true';
    elm.addEventListener('click', (e) => {
      if (cb) {
        cb()
      }
      
      elm.removeAttribute('data-click-event');
      e.preventDefault()
    }, {once: true})
  }
}

/**
 * Adds the click event listener for the toast close button
 */
export function initializeToast() {
	if (typeof(toast) != 'undefined' && toast != null) {
		toast.children[0].addEventListener('click', () => {
			toast.classList.toggle('closed')
		}, {once: true})
	} 
}